import Segment from '../shared/segment';
import Field from '../shared/field';
import { StudentExamType } from '../../api/student-exam';
import LessonReports from './lesson-reports';

export type ExamReportPropsType = {
  studentExam: StudentExamType;
};

function ExamReport({ studentExam }: ExamReportPropsType) {
  return (
    <Segment bg>
      <Field title='نام آزمون' content={studentExam.exam.name} />
      <Field title='تعداد سوالات' content={studentExam.exam.questionCount} />
      <Field title='نمره منفی' content={studentExam.exam.penalty ? 'دارد' : 'ندارد'} />
      {studentExam.data && studentExam.data.length && <LessonReports data={studentExam.data} />}
    </Segment>
  );
}

export default ExamReport;
